import React from 'react';
import {
  CustomCard,
  CustomCardContent,
  IconRow,
  InsightsCardTitle,
  CardText,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/styles';
import { Box } from '@mui/material';
import {
  fixedNumberWithCommas,
  numberWithCommasOrDash,
} from 'spw-shared/utils';
import {
  RoundSingleSummary,
  RoundVM,
  SeatsSummary,
} from 'spw-redux/modules/ou/types';
import { ALL_CATEGORIES } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/constants';
import {
  AMENITY_SPACES_CATEGORY,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  MEETING_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
} from 'spw-constants';
import { TabValue } from 'spw-esa-projects/building-details/occupancy-and-utilization/types';
import {
  CategoryDotWrapper,
  ColorDot,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/styles';

import { useCategoryColor } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/hooks';
import SelectedRoundsRow from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/selected-rounds-row';

type Props = {
  category: TabValue;
  spacesSummary?: RoundSingleSummary;
  seatsSummary?: SeatsSummary;
  selectedRounds: Omit<RoundVM, 'buildings'>[];
};

const iconsByCategory: { [key: string]: string } = {
  [ALL_CATEGORIES]: 'custom-meeting-default',
  [INDIVIDUAL_WORKSPACES_CATEGORY]: 'iw-custom-subcategory-default',
  [MEETING_SPACES_CATEGORY]: 'xl-conf-default',
  [AMENITY_SPACES_CATEGORY]: 'pantry-default',
  [SUPPORT_SPACES_CATEGORY]: 'idf-default',
};

const AverageSeatUsedPerSpace = ({
  category,
  spacesSummary,
  seatsSummary,
  selectedRounds,
}: Props) => {
  const color = useCategoryColor(category);

  return (
    <CustomCard elevation={0} className="margin-top-16">
      <CustomCardContent>
        <InsightsCardTitle>
          <CategoryDotWrapper>
            <ColorDot color={color} className="colorDot" />
          </CategoryDotWrapper>
          <Box display="flex">AVERAGE SEATS USED PER SPACE</Box>
        </InsightsCardTitle>
        <IconRow>
          <Box className="card-icon">
            <img
              alt="meeting-seat-icons"
              src={`/images/space-icons/${iconsByCategory[category]}.svg`}
              height={32}
            />
          </Box>
          <Box
            className="value"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {seatsSummary?.averageSeatsUsedPerSpace !== undefined
              ? fixedNumberWithCommas(seatsSummary?.averageSeatsUsedPerSpace, 1)
              : '--'}
          </Box>
        </IconRow>
        <SelectedRoundsRow selectedRounds={selectedRounds} />
        <CardText>
          <p>
            <b>{numberWithCommasOrDash(seatsSummary?.inUse)}</b> Observed Seats
            In Use /
          </p>
          <p>
            <b>{numberWithCommasOrDash(spacesSummary?.inUse)}</b> Observed
            Spaces In Use
          </p>
        </CardText>
      </CustomCardContent>
    </CustomCard>
  );
};

export default AverageSeatUsedPerSpace;
